import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Impact from "@/components/Impact";
import Services from "@/components/Services";
import Coverage from "@/components/Coverage";
import Belem from "@/components/Belem";
import Differentials from "@/components/Differentials";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function App() {
  return (
    <div className="App bg-[#0A0A0A] text-white">
      <Header />
      <main>
        <Hero />
        <Impact />
        <Services />
        <Coverage />
        <Belem />
        <Differentials />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
